import React, { Component } from 'react';
import CloseUpSVG from '../../svg/CloseUpSVG';
import { withStore } from '../store';
import { Service } from '../ApiService';
import Table from '../Table';
import { Link } from 'react-router-dom'
import Loader from '../Loader';

import EditUpSVG from '../../svg/EditUpSVG'

import Alert from '../Alert';

class EventTypes extends Component {

    constructor(props) {
        super(props);
        props.store.refreshEventTypes();
        this.state = {
            eventTypesList: []
        };
    }

    componentDidMount() {
        var component = this;
        Service.getEventTypes().then(data => component.setState({ eventTypesList: data }));
    }

    renderTypeName(value, row, index, col) {
        var deletedClassName = '';
        return (
            <li key={index} className={(col.className ? "table-content " + col.className : "table-content") + deletedClassName} style={{ "alignItems": "stretch" }}>
                <span style={{ 'backgroundColor': row['color'] }}></span>
                <span className='chapter'>{value}</span>
                <Link
                    className='round-button small-round-button light-grey-outline-button'
                    style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                    to={'/edit-event-type/' + row['id']}
                >
                    <EditUpSVG />
                </Link>
            </li>
        );
    }

    renderNotValue(value, row, index, col) {
        return (
            <li key={index} className="table-content" style={{ "alignItems": "stretch" }}>
                <span className='small-bold' style={{ 'color': value ? 'red' : 'green' }}>{value ? "NO" : "YES"}</span>
            </li>
        );
    }

    render() {
        const eventTypesList = this.state.eventTypesList;
        const columns = [
            { title: "Name", accesor: "title", className: "borders-when-display-block", render: this.renderTypeName.bind(this) },
            { title: "Active", accesor: "deleted", render: this.renderNotValue.bind(this) }
        ];

        return (
            <div className={(!this.props.hideEdit ? 'inner-pages-wrapper' : '') + ' ipw-600'}>
                {this.state.loading && <Loader />}

                {!this.props.hideEdit &&
                    <div className="flex-wrap align-center justify-space-between w-100 mb-2 ">
                        <h1 className='uppercase-text'><strong>Event types</strong></h1>
                        <a className='big-static-button static-button' href="/new-event-type"><p>NEW EVENT TYPE</p></a>
                    </div>
                }
                <Table columns={columns} data={eventTypesList} className={"break-at-500"} addHeadersForNarrowScreen={true} />

                {this.state.showDialog &&
                    <Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDialog: false })}
                        onOkButtonClick={this.onOkButtonClick}
                        cancelButtonText={this.cancelButtonText}
                        okButtonText={this.okButtonText}
                        mode='warning'
                    >
                        {this.dialogContent}
                    </Alert>
                }

            </div>
        );
    }
}

export default withStore(EventTypes);


// WEBPACK FOOTER //
// ./src/components/event/EventTypes.jsx